export const categories = [
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '娱乐圈最新八卦、明星私生活爆料',
    icon: 'ri-chat-smile-2-line',
    color: 'primary',
  },
  {
    slug: 'mingxing-dongtai',
    name: '明星动态',
    description: '明星行程、作品发布、社交媒体动态',
    icon: 'ri-star-line',
    color: 'accent',
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会事件、热点新闻、深度爆料',
    icon: 'ri-fire-line',
    color: 'secondary',
  },
  {
    slug: 'zongyi-yule',
    name: '综艺娱乐',
    description: '综艺节目、真人秀、娱乐节目爆料',
    icon: 'ri-tv-2-line',
    color: 'primary',
  },
  {
    slug: 'yingshi-zixun',
    name: '影视资讯',
    description: '电影、电视剧最新资讯与幕后爆料',
    icon: 'ri-film-line',
    color: 'accent',
  },
  {
    slug: 'wangluo-chigua',
    name: '网络吃瓜',
    description: '网络热门话题、网红动态、热搜事件',
    icon: 'ri-earth-line',
    color: 'secondary',
  },
  {
    slug: 'shishang-shenghuo',
    name: '时尚生活',
    description: '明星穿搭、时尚趋势、生活方式',
    icon: 'ri-shirt-line',
    color: 'primary',
  },
  {
    slug: 'tiyu-bagua',
    name: '体育八卦',
    description: '体育明星私生活、赛场内外趣闻',
    icon: 'ri-basketball-line',
    color: 'accent',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});